import { auth } from '../auth/firebase';
import { COOKIE_KEYS } from '../constants';
import { isIOS, removeTokenFromWebkit, sendTokenToWebkit } from './ios.util';
import Cookies from 'js-cookie';
import { isClient } from './nextjs.util';
import dayjs from 'dayjs';

export const removeJwtToken = () => {
  console.log('Removing JWT token');
  localStorage.removeItem(COOKIE_KEYS.Jwt);
  Cookies.remove(COOKIE_KEYS.Jwt);
  removeTokenFromWebkit();
};

export const refreshTokenIfExpired = async () => {
  const currentUser = auth.currentUser;
  if (!currentUser) return;

  try {
    const tokenResult = await currentUser.getIdTokenResult();
    const tokenAgeMs = Date.now() - Date.parse(tokenResult.issuedAtTime);
    // Si el token tiene menos de 55 minutos, no se hace nada.
    if (tokenAgeMs <= 55 * 60 * 1000) return;
    await currentUser.getIdToken(true);
  } catch (error) {
    console.error('Error checking token on focus:', error);
  }
};

export const setJwtToken = (token: string) => {
  if (isClient) {
    Cookies.set(COOKIE_KEYS.Jwt, token, {
      sameSite: 'None',
      path: '/',
      secure: true,
      expires: dayjs().add(1, 'years').toDate(),
    });
    localStorage.setItem(COOKIE_KEYS.Jwt, token);
    if (isIOS()) {
      sendTokenToWebkit(token);
    }
  }
};

export const refreshTokenIfExpiredOnVisilityChange = () => {
  if (document.visibilityState === 'visible') {
    refreshTokenIfExpired();
  }
};
